import _cloneDeep from 'lodash/cloneDeep';
import safeLocalStorage from 'safe-localstorage';
import errorService from 'src/services/error';

export default () => {
  const filters = {
    assetType: [],
    group: [],
    health: [],
    status: [],
    tag: [],
  };

  const filtersString = safeLocalStorage.get('filtering/filters');
  let savedFilters = {};
  if (filtersString) {
    try {
      savedFilters = JSON.parse(filtersString);
    } catch (error) {
      errorService.log(new Error(`Failed to load cached map filters with value: ${filtersString}`));
    }
  }

  Object.keys(filters).forEach((key) => {
    const savedValues = savedFilters[key];
    if (savedValues) {
      filters[key] = savedValues;
    }
  });

  let filterOutOfBounds = safeLocalStorage.get('filtering/filterOutOfBounds');
  if (filterOutOfBounds === 'true') {
    filterOutOfBounds = true;
  } else if (filterOutOfBounds === 'false') {
    filterOutOfBounds = false;
  } else {
    filterOutOfBounds = null;
  }

  let filterShared = safeLocalStorage.get('filtering/filterShared');
  if (filterShared === 'true') {
    filterShared = true;
  } else if (filterShared === 'false') {
    filterShared = false;
  } else {
    filterShared = null;
  }

  return {
    filteringOccurred: false,
    filterOutOfBounds,
    filterShared,
    filters,
    filtersInitialized: false,
    filtersTracked: _cloneDeep(filters),
    searchTerms: [],
  };
};
